<RepairDetail headerTextOther="Other Event / Repair" detailsType="other" ListURL="ORepairs/Repairs/RepairDetailSearch">
